<template>
  <div id="custom">
    <div class="header flex-between">
      <div class="header-text">
        <h1>自定义信息管理</h1>
      </div>
      <div class="header-button">
        <el-button icon="iconfont icon-xiugai1" @click.native="modifyPopupBtn"
          >修改</el-button
        >
      </div>
    </div>
    <!-- 修改弹窗 -->
    <div class="amend">
      <el-dialog
        width="65%"
        title="
自定义选项—选项名"
        :visible.sync="amendVisible"
        :closeOnClickModal="false"
      >
        <el-card>
          <el-button @click="createVisible = true">创建</el-button>
        </el-card>
        <el-card>
          <div style="margin-top: 10px">
            <el-table
              :data="modifyTableData"
              height="200px"
              show-header
              :header-cell-style="{
                background: '#FCFBF2',
                'text-align': 'center',
                color: '#6C6839',
                fontSize: '14px',
              }"
              :cell-style="{ 'text-align': 'center' }"
              border
              v-el-table-infinite-scroll="loadEffective"
              v-loading="loadingR"
              infinite-scroll-disabled="onLoadingR"
            >
              <el-table-column type="index" width="60"></el-table-column>
              <el-table-column width="180">
                <template slot-scope="scope">
                  <el-button @click="modifyBtn(scope.row)">修改</el-button>
                  <el-button>
                    <span @click="enableBtn(scope.row)">禁用</span>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                prop="description_CN"
                label="中文描述"
              ></el-table-column>
              <el-table-column prop="description_EN" label="英文描述">
              </el-table-column>
              <el-table-column prop="createUserName" label="创建人" width="120">
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="160">
                <template slot-scope="scope">
                  <div v-if="scope.row.createTime !== null">
                    {{ scope.row.createTime | dateFormat }}
                  </div>
                  <div el-else></div>
                </template>
              </el-table-column>
              <el-table-column
                prop="updateUserName"
                label="最后修改人"
                width="120"
              >
              </el-table-column>
              <el-table-column label="最后修改时间" width="160">
                <template slot-scope="scope">
                  <div v-if="scope.row.updateTime !== null">
                    {{ scope.row.updateTime | dateFormat }}
                  </div>
                  <div el-else></div>
                </template>
              </el-table-column>
            </el-table>
            <el-alert
              v-if="isMoreR"
              title="没有更多数据了!"
              type="warning"
              center
              :closable="false"
            >
            </el-alert>
          </div>
        </el-card>
        <el-card style="color: #6c6937">无效值</el-card>
        <!-- 无效值 -->
        <el-card>
          <div style="margin-top: 10px">
            <el-table
              :data="modifyTableData1"
              height="200px"
              show-header
              :header-cell-style="{
                background: '#FCFBF2',
                'text-align': 'center',
                color: '#6C6839',
                fontSize: '14px',
              }"
              :cell-style="{ 'text-align': 'center' }"
              border
              v-el-table-infinite-scroll="loadInvalid"
              v-loading="loadingT"
              infinite-scroll-disabled="onLoadingT"
            >
              <el-table-column type="index" width="60"></el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <el-button>
                    <span @click="disableBtn(scope.row)">启用</span>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                prop="description_CN"
                label="中文描述"
              ></el-table-column>
              <el-table-column prop="description_EN" label="英文描述">
              </el-table-column>
              <el-table-column prop="createUserName" label="创建人" width="120">
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="160">
                <template slot-scope="scope">
                  <div v-if="scope.row.createTime !== null">
                    {{ scope.row.createTime | dateFormat }}
                  </div>
                  <div el-else></div>
                </template>
              </el-table-column>
              <el-table-column
                prop="updateUserName"
                label="最后修改人"
                width="120"
              >
              </el-table-column>
              <el-table-column label="最后修改时间" width="160">
                <template slot-scope="scope">
                  <div v-if="scope.row.updateTime !== null">
                    {{ scope.row.updateTime | dateFormat }}
                  </div>
                  <div el-else></div>
                </template>
              </el-table-column>
            </el-table>
            <el-alert
              v-if="isMoreT"
              title="没有更多数据了!"
              type="warning"
              center
              :closable="false"
            >
            </el-alert>
          </div>
        </el-card>
      </el-dialog>
    </div>
    <!-- 创建弹窗 -->
    <div>
      <el-dialog
        width="40%"
        title="选项值—创建"
        :visible.sync="createVisible"
        :closeOnClickModal="false"
      >
        <el-form
          ref="createForm"
          :model="createForm"
          :rules="createRules"
          label-width="150px"
          style="margin-top: 20px"
        >
          <el-row :gutter="50">
            <el-form-item label="自定义选项">
              <el-input v-model="changeValue.defineKind" disabled></el-input>
            </el-form-item>
          </el-row>
          <el-row :gutter="50">
            <el-form-item label="基础信息中文描述" prop="description_CN">
              <el-input v-model="createForm.description_CN"></el-input>
            </el-form-item>
          </el-row>
          <el-row :gutter="50">
            <el-form-item label="英文描述" prop="description_EN">
              <el-input v-model="createForm.description_EN"></el-input>
            </el-form-item>
          </el-row>
          <el-row :gutter="50">
            <el-form-item label="状态">
              <el-radio-group v-model="createForm.state" prop="state">
                <el-radio :label="0">启用</el-radio>
                <el-radio :label="1">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
          <el-row :gutter="50">
            <el-form-item label="排序">
              <el-input
                v-model="createForm.sortIndex"
                onkeyup="value=value.replace(/[^\d]/g,'')"
              ></el-input>
            </el-form-item>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="createList">保 存</el-button>
          <el-button @click="createVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改数据弹窗 -->
    <div class="modify">
      <el-dialog
        width="40%"
        title="选项值—修改"
        :visible.sync="modifyVisible"
        :closeOnClickModal="false"
      >
        <div>
          <el-form
            ref="form"
            :model="modifyForm"
            label-width="150px"
            style="margin-top: 20px"
          >
            <el-row :gutter="50">
              <el-form-item label="自定义选项">
                <el-input v-model="modifyForm.defineKind" disabled></el-input>
              </el-form-item>
            </el-row>
            <el-row :gutter="50">
              <el-form-item label="基础信息中文描述">
                <el-input v-model="modifyForm.description_CN"></el-input>
              </el-form-item>
            </el-row>
            <el-row :gutter="50">
              <el-form-item label="英文描述">
                <el-input v-model="modifyForm.description_EN"></el-input>
              </el-form-item>
            </el-row>
            <el-row :gutter="50">
              <el-form-item label="状态">
                <el-radio-group v-model="modifyForm.state">
                  <el-radio :label="0">启用</el-radio>
                  <el-radio :label="1">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-row>
            <el-row :gutter="50">
              <el-form-item label="排序">
                <el-input
                  v-model="modifyForm.sortIndex"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                ></el-input>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modifyListSave">保 存</el-button>
          <el-button @click="modifyVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 列表 -->
    <div>
      <el-card shadow="never">
        <el-table
          height="680px"
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          v-el-table-infinite-scroll="load"
          v-loading="loading"
          infinite-scroll-disabled="onLoading"
          highlight-current-row
        >
          <el-table-column label width="50">
            <template slot-scope="scope">
              <el-radio
                style="margin-left: 10px"
                :label="scope.$index"
                v-model="radio"
                @change.native="handleSelectionChange(scope.row)"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column prop="defineKind" label="编码"> </el-table-column>
          <el-table-column prop="kindDesc_CN" label="选项名称">
          </el-table-column>
          <el-table-column prop="createUserName" label="创建人">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间">
            <template slot-scope="scope">
              <div v-if="scope.row.createTime !== null">
                {{ scope.row.createTime | dateFormat }}
              </div>
              <div el-else></div>
            </template>
          </el-table-column>
          <el-table-column prop="updateUserName" label="最后修改人">
          </el-table-column>
          <el-table-column label="最后修改时间">
            <template slot-scope="scope">
              <div v-if="scope.row.updateTime !== null">
                {{ scope.row.updateTime | dateFormat }}
              </div>
              <div el-else></div>
            </template>
          </el-table-column>
        </el-table>
        <el-alert
          v-if="isMore"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        >
        </el-alert>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  defineDescPageApi,
  definedQueryApi,
  enableApi,
  disableApi,
  definedInsertApi,
  definedUpdateApi,
} from "@/api/shop";
export default {
  name: "centre",
  data() {
    return {
      radio: "",
      // isMore:false,
      loading: false,
      loadingR: false,
      loadingT: false,
      amendVisible: false,
      createVisible: false,
      modifyVisible: false,
      btnStatus: 0,
      formInline: {
        user: "",
        region: "",
      },
      defineID: "",
      createForm: {},
      // 修改
      modifyTableData: [],
      modifyTableData1: [],
      modifyForm: {},
      modifyRowValue: [],
      tableData: [],
      changeValue: [],
      pages: 0, //总页码
      pagesR: 0, //总页码
      pagesT: 0, //总页码
      count: 1,
      countR: 1,
      countT: 1,
      // 创建正则
      createRules: {
        description_CN: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        description_EN: [
          { required: true, message: "英文描述内容不能为空", trigger: "blur" },
        ],
        state: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
    };
  },
  created() {
    this.defineList();
  },
  computed: {
    isMore() {
      //当起始页数等于总页数时停止加载
      return this.count >= this.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    isMoreR() {
      //当起始页数等于总页数时停止加载
      return this.countR >= this.pagesR;
    },
    onLoadingR() {
      return this.loadingR || this.isMoreR;
    },
    isMoreT() {
      //当起始页数等于总页数时停止加载
      return this.countT >= this.pagesR;
    },
    onLoadingT() {
      return this.loadingT || this.isMoreR;
    },
  },
  methods: {
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    handleSelectionChange(val) {
      this.changeValue = val;
      // console.log(val)
    },
    async defineList() {
      let queryInfo = {
        pageNo: this.count,
        pageSize: 50,
      };
      await defineDescPageApi(queryInfo).then((res) => {
        this.tableData = this.tableData.concat(res.data.list); //因为每次后端返回的都是数组，所以这边把数组拼接到一起
        this.pages = res.data.pages;
        this.loading = false;
      });
    },
    load() {
      //滑到底部时进行加载
      this.loading = true;
      setTimeout(() => {
        this.count += 1; //页数+1
        this.defineList(); //调用接口，此时页数+1，查询下一页数据
      }, 500);
    },
    loadEffective() {
      //滑到底部时进行加载
      this.loadingR = true;
      setTimeout(() => {
        this.countR += 1; //页数+1
        this.modifyList(); //调用接口，此时页数+1，查询下一页数据
      }, 500);
    },
    loadInvalid() {
      //滑到底部时进行加载
      this.loadingT = true;
      setTimeout(() => {
        this.countT += 1; //页数+1
        this.modifyList1(); //调用接口，此时页数+1，查询下一页数据
      }, 500);
    },
    // 修改弹窗
    modifyPopupBtn() {
      if (this.changeValue == undefined || this.changeValue == "")
        return this.$message.info("请选择数据!");
      this.amendVisible = true;
      this.countR = 1;
      this.countT = 1;
      this.modifyTableData = [];
      this.modifyTableData1 = [];
      this.modifyList();
      this.modifyList1();
    },
    //修改列表数据---有效
    modifyList() {
      definedQueryApi({
        defineKind: this.changeValue.defineKind,
        state: 0,
        pageNo: this.countR,
        pageSize: 50,
      }).then((res) => {
        if (res.success) {
          this.modifyTableData = this.modifyTableData.concat(res.data.list);
          this.pagesR = res.data.pages;
          this.loadingR = false;
        }
      });
    },
    //修改列表数据---无效
    modifyList1() {
      definedQueryApi({
        defineKind: this.changeValue.defineKind,
        state: 1,
        pageNo: this.countT,
        pageSize: 50,
      }).then((res) => {
        if (res.success) {
          this.modifyTableData1 = this.modifyTableData1.concat(res.data.list);
          this.pagesT = res.data.pages;
          this.loadingT = false;
        }
      });
    },
    modifyBtn(val) {
      this.modifyVisible = true;
      this.modifyForm = val;
      console.log(val);
    },
    // 启用按钮
    disableBtn(val) {
      this.$confirm("", "是否真的启用?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          enableApi({ userDefineID: val.userDefineID }).then(() => {
            // console.log(res);
            this.countR = 1;
            this.modifyTableData = [];
            this.modifyTableData1 = [];
            this.modifyList();
            this.modifyList1();
          });
          this.$message({
            type: "success",
            message: "启用成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //禁用按钮
    enableBtn(val) {
      console.log(val);
      this.$confirm("", "是否真的禁用?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          disableApi({ userDefineID: val.userDefineID }).then((res) => {
            if (res.success) {
              this.countT = 1;
              this.modifyTableData = [];
              this.modifyTableData1 = [];
              this.modifyList();
              this.modifyList1();
            }
          });
          this.$message({
            type: "success",
            message: "禁用成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 新增
    createList() {
      this.$refs.createForm.validate((valid) => {
        if (valid) {
          definedInsertApi({
            defineKind: this.changeValue.defineKind,
            description_CN: this.createForm.description_CN,
            description_EN: this.createForm.description_EN,
            sortIndex: this.createForm.sortIndex,
            state: this.createForm.state,
          }).then((res) => {
            if (res.message !== "success")
              return this.$message.success("新增数据成功!");
            this.createVisible = false;
            this.count = 1;
            this.modifyTableData = [];
            this.modifyTableData1 = [];
            this.modifyList(); //修改列表数据--有效
            this.modifyList1(); //修改列表数据--无效
          });
        }
      });
    },
    async modifyListSave() {
      await definedUpdateApi({
        defineKind: this.modifyRowValue.defineKind,
        description_CN: this.modifyForm.description_CN,
        description_EN: this.modifyForm.description_EN,
        sortIndex: this.modifyForm.sortIndex,
        state: this.modifyForm.state,
        userDefineID: this.modifyForm.userDefineID,
      }).then((res) => {
        if (res.message == "success") {
          this.modifyVisible = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#custom {
  // height: 1400px;
  height: 100%;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }
  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  .el-dialog__header {
    background-color: #f3f1dd;
  }
  .el-dialog__title {
    font-size: 14px;
    font-weight: 700;
    color: #6c6937;
  }
  .el-dialog__body {
    padding: 0 20px 0 20px;
  }
  .el-dialog__footer {
    height: 60px;
    text-align: center;
    background-color: #f2f2f2;
  }
  .el-button:hover {
    background-color: #b5b386;
    color: #f2f2f2 !important;
  }
  .el-input__inner {
    width: 90%;
  }
}
</style>
